import React from "react";

function blog(){
    return <>
        <p className="blog">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque et elit ultrices, feugiat elit placerat, interdum dui. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Maecenas nec eros ut ligula ullamcorper mattis at id mi. Maecenas accumsan magna sed tristique mollis. Morbi in interdum massa. Nullam egestas rutrum felis, eu viverra elit ultrices eget. Nulla semper, justo nec varius dapibus, leo justo interdum purus, non vehicula nisi libero vitae purus.

Praesent vitae ornare sem. 
</p>
    </>
}

export default blog;